const upperCaseFirstChar = content => content[0].toUpperCase() + content.slice(1)

export default upperCaseFirstChar